/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import { useHistory } from "react-router";
import withReactContent from "sweetalert2-react-content";
import api from "../../utils/axiosApi";
import { option, Toast } from "../../utils/sweetalert";

function Tables() {
  const history = useHistory();
  const PAGE_SIZE = 20;
  const localToken =
    window.sessionStorage.getItem("jwtuser") || localStorage.getItem("jwtuser");
  const [users, setUsers] = useState([]);
  const [numberUsers, setNumberUsers] = useState(0);
  const [pages, setPages] = useState({
    actualPage: 0,
    maxPages: 1,
  });
  useEffect(() => {
    const requestcalendarios = async () => {
      try {
        const resp = await api.get(
          `/backoffice/users?page[number]=0&page[size]=${PAGE_SIZE}`,
          {
            headers: { Authorization: `Bearer ${localToken}` },
          }
        );

        setUsers(resp.data.data);

        const totalUsers = resp.data.meta.page.total;
        const cantPag = Math.ceil(totalUsers / PAGE_SIZE);

        setNumberUsers(totalUsers);
        setPages((prev) => ({ ...prev, maxPages: cantPag }));
      } catch (error) {
        // Manejo de error
      }
    };

    requestcalendarios();
  }, []);

  const handleDelete = async (c) => {
    const MySwal = withReactContent(option);
    const resp = await MySwal.fire({
      title: (
        <p style={{ fontSize: "22px", zIndex: 30000 }}>
          Desea Eliminar Completamente este usuario?
        </p>
      ),
      text: "Presione eliminar para continuar o presione afuera para salir",
      confirmButtonText: "Eliminar",
      icon: "question",
      focusConfirm: false,
    });
    if (resp.isConfirmed) {
      try {
        const localToken =
          window.sessionStorage.getItem("jwtuser") ||
          localStorage.getItem("jwtuser");
        const respbd = await api.delete(`/user/delete/${c._id}`, {
          headers: {
            Authorization: `Bearer ${localToken}`,
          },
        });
        if (!respbd.data.error) {
          const calendarioscopy = [...users];
          const ideliminar = calendarioscopy.findIndex((element) => {
            return element._id === c._id;
          });
          calendarioscopy.splice(ideliminar, 1);
          setUsers(calendarioscopy);
          const MySwal = withReactContent(Toast);
          await MySwal.fire({
            title: (
              <p style={{ fontSize: "1.5rem" }}>
                usuario eliminado Exitosamente
              </p>
            ),
            icon: "success",
          });
        } else {
          const MySwal = withReactContent(Toast);
          await MySwal.fire({
            title: <p style={{ fontSize: "1.5rem" }}>Password invalida</p>,
            icon: "error",
          });
        }

        setNumberUsers(numberUsers - 1);
      } catch (error) {
        //console.log(error)
      }
    }
  };

  const handlehide = async (c) => {
    try {
      //const code = state.calendar.code
      //const auth = state.user.token  //cookies.get('jwtuser')
      var List = [...users];
      const blogId = List.findIndex((u) => u._id === c._id);
      if (!(blogId >= 0)) {
        return;
      }

      const respbd = await api.put(`/user/ToggleTrack/${c._id}`);
      if (!respbd.data.error && blogId >= 0) {
        List[blogId] = { ...c, noTrack: !c.noTrack };
        setUsers(List);
        return true;
      }
    } catch (error) {
      //console.log(error)
      return error;
    }
  };
  const handleUnlockCompany = async (id) => {
    try {
      await api.patch(`/agencias/${id}/admin-unlock-functionalities`);
      const MySwal = withReactContent(Toast);
      await MySwal.fire({
        title: <p style={{ fontSize: "1.5rem" }}>Agencia desbloqueada</p>,
        icon: "info",
      });
    } catch (error) {
      //console.log(error)
      return error;
    }
  };
  const nextPage = async () => {
    const next = pages.actualPage + 1;
    if (next >= pages.maxPages) return;

    const resp = await api.get(
      `/backoffice/users?page[number]=${next}&page[size]=${PAGE_SIZE}`,
      {
        headers: {
          Authorization: `Bearer ${localToken}`,
        },
      }
    );

    setUsers(resp.data.data);
    setNumberUsers(resp.data.meta.page.total);
    setPages((prev) => ({ ...prev, actualPage: next }));
  };

  const PrevPage = async () => {
    const prevPage = pages.actualPage - 1;
    if (prevPage < 0) return;

    const resp = await api.get(
      `/backoffice/users?page[number]=${prevPage}&page[size]=${PAGE_SIZE}`,
      {
        headers: {
          Authorization: `Bearer ${localToken}`,
        },
      }
    );

    setUsers(resp.data.data);
    setNumberUsers(resp.data.meta.page.total);
    setPages((prev) => ({ ...prev, actualPage: prevPage }));
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col className="pr-md-1" xs="6" md="4">
                    <CardTitle tag="h4">Usuarios</CardTitle>
                  </Col>
                  <Col className="pr-md-1" xs="6" md="4">
                    <CardTitle tag="h4">
                      Usuarios registrados: {numberUsers}
                    </CardTitle>
                  </Col>
                  <Col className="pr-md-1" md="4">
                    <Button
                      disabled={pages.actualPage === 0}
                      onClick={PrevPage}
                    >
                      Anterior
                    </Button>
                    <Button disabled>
                      {pages.actualPage + 1} de {pages.maxPages}
                    </Button>
                    <Button
                      disabled={pages.actualPage >= pages.maxPages - 1}
                      onClick={nextPage}
                    >
                      Siguiente
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody style={{ overflowX: "auto" }}>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th></th>
                      <th>Nombre</th>
                      <th>Apellido</th>
                      <th>Email</th>
                      <th>Teléfono</th>
                      <th>Dirección</th>
                      <th>Tutorial Completo</th>
                      <th>Nombre de la Empresa</th>
                      <th>Correo de la Empresa</th>
                      <th>Dirección de la Empresa</th>
                      <th>Teléfono de la Empresa</th>
                      <th>RUT de la Empresa</th>
                      <th>RNT de la Empresa</th>
                      <th>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((c, i) => {
                      return (
                        <tr key={`users-${i}`}>
                          <td>
                            <Button
                              color="link"
                              size="sm"
                              onClick={() =>
                                history.push({
                                  pathname: `/admin/ActualizarUsuario/${c._id}`,
                                  state: c,
                                })
                              }
                              style={{ padding: 0, marginRight: "8px" }}
                            >
                              <i className="tim-icons icon-pencil" />
                            </Button>
                          </td>
                          <td>{c.name}</td>
                          <td>{c.lastName}</td>
                          <td>{c.email}</td>
                          <td>{c.telfFijo}</td>
                          <td>{c.direccion}</td>
                          <td>{c.tutorialComplete ? "Sí" : "No"}</td>
                          <td>{c.agency?.nameAgency}</td>
                          <td>{c.agency?.emailPublico}</td>
                          <td>{c.agency?.address}</td>
                          <td>{c.agency?.phone}</td>
                          <td>{c.agency?.rut}</td>
                          <td>{c.agency?.rnt}</td>
                          <td>
                            {
                              c.level === "agency"
                              && (
                              c.agency?.status === "free" ? 
                              (<Button
                                onClick={() => {
                                  handleUnlockCompany(c._id);
                                }}
                                size="sm"
                                type="button"
                                color="secondary"
                              >
                                Desbloquear agencia
                              </Button>
                            ) : (
                              <p
                                size="sm"
                                type="button"
                                color="secondary"
                                className="mb-0"
                              >
                                Agencia desbloqueada
                              </p>
                            )
                            )}
                            <Button
                              onClick={() => {
                                handlehide(c);
                              }}
                              size="sm"
                              type="button"
                              color="primary"
                            >
                              {c.noTrack ? "Trackear" : "No Trackear"}
                            </Button>
                            <Button
                              onClick={() => {
                                handleDelete(c);
                              }}
                              size="sm"
                              type="button"
                              color="danger"
                            >
                              Eliminar
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Tables;
